<template>
  <el-dialog
    v-model="visible"
    title="生成海报"
    width="520px"
    :close-on-click-modal="true"
    @close="handleClose"
  >
    <!-- 预览区 -->
    <div class="poster-preview" v-html="svgHtml" v-if="svgHtml && !loading"></div>
    <div class="poster-loading" v-if="loading">
      <el-icon class="is-loading" :size="32"><Loading /></el-icon>
      <p>海报生成中...</p>
    </div>

    <!-- 操作按钮 -->
    <template #footer>
      <div class="poster-actions">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleDownload" :disabled="!pngDataUrl">
          下载图片
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'
import { Loading } from '@element-plus/icons-vue'
import { renderPoster, downloadPng } from './composables/usePosterRenderer'
import { API_CONFIG } from '@/config'

const props = defineProps({
  modelValue: Boolean,
  type: { type: String, required: true },
  data: { type: Object, default: () => ({}) }
})

const emit = defineEmits(['update:modelValue'])

const visible = ref(false)
const svgHtml = ref('')
const pngDataUrl = ref('')
const loading = ref(false)

watch(() => props.modelValue, (val) => {
  visible.value = val
  if (val && props.type) generate()
})

watch(visible, (val) => {
  if (!val) emit('update:modelValue', false)
})

async function generate() {
  loading.value = true
  svgHtml.value = ''
  pngDataUrl.value = ''
  try {
    const result = await renderPoster(props.type, props.data)
    svgHtml.value = result.svgHtml
    pngDataUrl.value = result.pngDataUrl
    trackPosterRendered()
  } catch (e) {
    console.error('[PosterDialog] render failed:', e)
  } finally {
    loading.value = false
  }
}

// 渲染成功埋点：fire-and-forget，仅登录态发送，失败静默，不影响海报功能
function trackPosterRendered() {
  try {
    const token = localStorage.getItem('token')
    if (!token) return
    fetch(`${API_CONFIG.baseUrl}${API_CONFIG.endpoints.persona.interaction}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
      body: JSON.stringify({
        type: 'poster',
        question: props.type,
        result: {
          template: props.type,
          summary: props.data?.mbtiType || props.data?.sbtiCode || ''
        }
      })
    }).catch(() => {})
  } catch {
    // 静默失败，不影响海报功能
  }
}

function handleDownload() {
  if (pngDataUrl.value) {
    const names = { mbti: 'MBTI海报', sbti: 'SBTI海报', invite: '邀请海报', agent: 'Agent海报', app: '随心分享', naming: '姓名评分卡片' }
    downloadPng(pngDataUrl.value, `${names[props.type] || '海报'}.png`)
  }
}

function handleClose() {
  visible.value = false
}
</script>

<style scoped>
.poster-preview {
  display: flex;
  justify-content: center;
  max-height: 65vh;
  overflow-y: auto;
}
.poster-preview :deep(svg) {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}
.poster-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 60px 0;
  color: #999;
}
.poster-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
</style>
